import React, {Component, ErrorInfo, ReactNode} from 'react';
import ErrorPage from "../components/ErrorPage";

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
}

class MiddlewareError extends Component<Props, State> {
    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        if (_.message === "ResizeObserver loop limit exceeded") {
            return { hasError: false }
        }
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    public render() {
        if (this.state.hasError) {
            return <ErrorPage/>;
        }

        return this.props.children;
    }
}

export default MiddlewareError;